import React, { Component } from 'react';

import { Form, Field } from 'react-final-form';
import NonValidatedField from '../NonValidatedField/NonValidatedField';
import ValidatedField from '../ValidatedField/ValidatedField';
import ValidatedCheckbox from '../ValidatedCheckbox/ValidatedCheckbox';
import AutoCompleteField from '../AutoCompleteField/AutoCompleteField';
import Signature from '../Signature/Signature';
import FileUpload from '../FileUpload/FileUpload';

const Step6 = (props) => {
    return (
        <div>
            <h2>הצהרת אי שימוש בסמים</h2>
            <ol>
                
              <li>מצהיר/ה ומתחייב/ת שלא ליטול סמים מיום חתימת הצהרה זו ואילך, למעט שימוש בסמים <b><u>באישור משרד הבריאות</u></b>.</li>
              <li>הוסבר לי באופן חד משמעי, והדבר מוסכם עלי, כי אי-עמידה בהצהרתי זו, ו/או בהתחייבותי שלא ליטול סמים מיום חתימת הצהרה זו, תמנע ממני מלהמשיך וליטול חלק במימוש התקשרות, הכוללת מידע מסווג, בין הספק למשהב"ט וכן למניעת כניסתי, לצורך מימוש התקשרות בין  הספק למשהב"ט, למתקנים ולאתרים שהכניסה אליהם מוגבלת מטעמי ביטחון בין במשהב"ט ובין בצה"ל.</li>
              <li>אני מוכן/ה ומסכים/ה להיבדק בפוליגרף לאימות הצהרתי זו. כמו כן אני מוכן/ה להיבדק בפוליגרף בנושא זה גם בעתיד בכל עת שאדרש, וזאת כל עוד יתקיימו הנסיבות בגללן נדרשה בדיקה ביטחונית, קרי: כל עוד אהיה עובד של המעסיק הנ"ל וככזה אטול חלק במימוש התקשרות, הכוללת מידע מסווג, בין הספק למשהב"ט ו/או התקשרות המצריכה כניסתי למתקנים ולאתרים שהכניסה אליהם מוגבלת מטעמי ביטחון, בין במשהב"ט ובין בצה"ל.</li>
              <li>אני מצהיר/ה בזאת ומתחייב/ת לנהוג על-פי התחייבותי כאמור.</li>
            </ol>
            <br/>
            <br/>
            <ValidatedCheckbox name="isApproveDrugs" label="ולראיה באתי על החתום" validated={true} tabIndex="1"/>
        </div>
    );
  };
  
  export default Step6;